// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"195":"page-data","495":"page-intro","610":"page-literature","689":"page-design","764":"page-material"}[chunkId] + "." + {"195":"b48096bd","495":"7f1cac4e","610":"0ebb4273","689":"ec9d4c76","764":"8b0d5ce4"}[chunkId] + ".css";
};